<template>
  <div class="container-fluid pt-2">
    <div class="row mb-3">
      <div class="col-md-4">
        <h3 class="text-weight-900 text-primary">Taxes & Levies</h3>
      </div>

      <div class="col-md-8 text-right">
        <div class="dropdown">
  <button class="btn btn-outline-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
   Actions
  </button>
  <div class="dropdown-menu">
    <a class="dropdown-item" href="#"@click="exportExcel">
          <i class="bi bi-download"></i> Download Excel</a>
    <a class="dropdown-item" href="#"@click="exportPdf">
          <i class="bi bi-download"></i> Download Pdf</a>

  </div>
</div>

      </div>
    </div>

    <!-- Filters -->
      <div class="row">
        <div class="col-6 col-md-4 border-right">
          <div class="border-bottom border-primary text-center bg-success-light" style="width:75%; margin:0 auto;">
            <p class="text-bold">{{ summary.total_debit }}</p><small>Total Debit</small>
          </div>
        </div>
        <div class="col-6 col-md-4 border-right">
          <div class="border-bottom border-primary text-center bg-success-light" style="width:75%; margin:0 auto;">
            <p class="text-bold">{{  summary.total_credit }}</p><small>Total Credit</small>
          </div>
        </div>
        <div class="col-6 col-md-4 border-right">
          <div class="border-bottom border-primary text-center bg-danger-light" style="width:75%; margin:0 auto;">
            <p class="text-bold">{{  summary.closing_balance }}</p><small>Closing Balance</small>
          </div>
        </div>

      </div>
     <!-- Filters -->
    <div class="row mb-2">
       <div class="col-md-4 py-2">
        <select class="form-control" v-model="filters.description">
          <option value="">All Taxes</option>
          <option v-for="t in taxes" :key="t.id" :value="t.tax">
            {{ t.tax }}
          </option>
        </select>
      </div>
       <div class="col-md-4 py-2">
        <select class="form-control" v-model="filters.description">
          <option value="">All Taxes</option>
          <option v-for="t in taxes" :key="t.id" :value="t.tax">
            {{ t.tax }}
          </option>
        </select>
      </div>
       <div class="col-md-4 py-2">
        <select class="form-control" v-model="filters.description">
          <option value="">All Taxes</option>
          <option v-for="t in taxes" :key="t.id" :value="t.tax">
            {{ t.tax }}
          </option>
        </select>
      </div>

    </div>

    <!-- Table -->
    <b-table
      :items="items"
      :fields="fields"
      small
      striped
      hover
      responsive
    >
      <template #cell(model_type)="row">
        <a title="view order" :href="'/orders?order-number=' + row.item.model_id">
            <span class="badge badge-info">
          {{ normalizeModel(row.item.model_type) }}
        </span></a>

      </template>

      <template #cell(credit)="row">
        {{ convertCurrencyToLocal(row.item.credit) }}
      </template>

      <template #cell(date)="row">
        {{ formatDate(row.item.date) }}
      </template>
    </b-table>

    <b-pagination
      v-model="page"
      :total-rows="total"
      :per-page="perPage"
      @change="fetchLedgers"
    />
  </div>
</template>
<script>
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";

    export default {
    name: 'TaxLedgerManager',
    components: {
        DateRangePicker
        },


  data() {
    return {
        dateRange: {
        startDate: null,
        endDate: null,
        },
        autoApply: true,
        append_to_body: true,
        datepicker_opens: 'right',
        ranges: false,

      items: [],
      taxes: [],
      page: 1,
      perPage: 20,
      total: 0,
      filters: {
        from: '',
        to: '',
        description: ''
      },
      summary:{},
      fields: [
         { key: 'description', label: 'Tax / Levy' },
        { key: 'date', label: 'Date' },

        { key: 'model_type', label: 'Source' },

        { key: 'credit', label: 'Amount' }
      ]
    };
  },

  mounted() {
    this.fetchLedgers();
    this.getTaxes();
  },
watch: {
  dateRange: {
    deep: true,
    handler(after) {
      if (after.startDate && after.endDate) {
        this.filters.from = after.startDate.toISOString().split('T')[0];
        this.filters.to   = after.endDate.toISOString().split('T')[0];
      } else {
        this.filters.from = null;
        this.filters.to   = null;
      }

      this.fetchLedgers();
    }
  }
},
  methods: {
    async fetchLedgers() {
      const res = await axios.get('/api/tax-ledgers', {
        params: { ...this.filters, page: this.page }
      });

      this.items = res.data.data.data;
      this.summary = res.data.summary;
      this.total = res.data.data.total;
      this.perPage = res.data.data.per_page;
    },

    async getTaxes() {
      const res = await axios.get('/api/taxes');
      this.taxes = res.data.data;
    },

    normalizeModel(type) {
      if (!type) return '-';
      return type.split('\\').pop();
    },

    formatCurrency(v) {
      return `KES ${Number(v || 0).toFixed(2)}`;
    },

    formatDate(d) {
      return moment(d).format('DD-MM-YYYY');
    },


  exportExcel() {
    axios({
      url: '/api/download-ledgers-pdf',
      method: 'GET',
      params: { format: 'excel', ...this.filters },
      responseType: 'blob', // important for files
    })
    .then((response) => {
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Tax-Ledger-${this.fromDate || ''}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(link.href);
    })
    .catch((error) => {
      console.error(error);
      this.$toasts?.push({ type: 'danger', message: 'Failed to export Excel' });
    });
  },

  exportPdf() {
    axios({
      url: '/api/download-ledgers-pdf',
      method: 'GET',
      params: { format: 'pdf', ...this.filters },
      responseType: 'blob',
    })
    .then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Tax-Ledger-${this.fromDate || ''}.pdf`;
      link.click();
      window.URL.revokeObjectURL(link.href);
    })
    .catch((error) => {
      console.error(error);
      this.$toasts?.push({ type: 'danger', message: 'Failed to export PDF' });
    });
  }

  }
};

</script>
